export default __webpack_public_path__ + "static/media/spread-eloz-icon.59ae88ba.png";